import { WalletInterface } from '@api';

import { WalletConnectType } from './walletsConfig';

export const getConnectedWallet = (wallets: WalletInterface[], connectType: WalletConnectType) => {
  return wallets?.find((wallet) => connectType === wallet.attributes.network);
};
